<div class="download-app">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                <div class="d-flex flex-column justify-content-center down-text">
                    <div class="download-txt">
                        <h5>{{"Download Now" | translate}}!</h5>
                        <h2>{{downloadAppData.title}}</h2>
                        <p>{{"Enjoy the best exclusive offers and collect " | translate}} {{companyName | translate}} {{" travel points to get more discount" | translate}}...</p>
                    </div>
                    <div class="qr-download d-flex align-items-center">
                        <img src={{downloadAppData.qr_code_image}} alt="">
                        <div class="scan-txt ms-3">
                            <p>{{"Scan this QR code for" | translate}}</p>
                            <span>{{"Download The App" | translate}}</span>
                        </div>
                    </div>
                    <div class="marketplace-download mt-3">
                      <ul class="ps-0 d-flex align-items-center">
                        <li>
                          <a [href]="downloadAppData.google_playstore_url" target="_blank">
                            <img src="assets/image/playstore.png" alt="Google Play Store">
                          </a>
                        </li>
                        <li>
                          <a [href]="downloadAppData.app_store_url" target="_blank">
                            <img src="assets/image/appstore.png" alt="App Store">
                          </a>
                        </li>
                        <li>
                          <a [href]="downloadAppData.HUAWEI_store_url" target="_blank">
                            <img src="assets/image/appgallary.png" alt="Huawei AppGallery">
                          </a>
                        </li>
                      </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div class="download-app-img">
                  <img class="w-full ltr-dir-img" [src]="getImageSrc()" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="main-footer">
    <div class="container">
        <div class="row gx-5">
            <div class="col-lg-3 col-md-6 col-xs-12">
                <div class="footer-cont">
                    <h5>{{"About" | translate}} {{companyName | translate}}</h5>
                    <p>{{ generalData.shortAboutUs | translate }}</p>
                    <a [routerLink]="['/page/about-us']" class="read-more-btn">{{"Read more" | translate}}</a>
                </div>
            </div>
            <div class="col-lg-5 col-md-6 col-xs-12">
                <div class="footer-cont footer-links">
                    <h5>{{"Quick Links" | translate}}</h5>
                    <div class="bottom-site-urls">
                        <ul>
                            <li>
                                <a href="#">{{"Special Offers" | translate}}
                                </a>
                            </li>
                            <li>
                                <a href="#">{{"Summer Offers" | translate}}
                                </a>
                            </li>
                            <li>
                                <a href="#">{{"Bridal Shows" | translate}}
                                </a>
                            </li>
                            <li>
                                <a href="#">{{"Explore Destinations" | translate}}
                                </a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a [routerLink]="['/page/terms-and-conditions']">{{"Terms & Conditions" | translate}}
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/page/privacy-policy']">{{"Privacy Policy" | translate}}
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/page/faq']">{{"FAQ's" | translate}}
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/page/about-us']">{{ "About us" | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-xs-12">
                <div class="footer-cont social-links">
                    <h5>{{"Follow us on" | translate}}</h5>
                    <ul>
                        <li *ngFor="let socialMedia of socialMediaData">
                            <a href={{socialMedia.link}} target="_blank"><img src="assets/image/social/{{socialMedia.name}}.png" alt="">{{socialMedia.name | translate}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-xs-12">
                <div class="footer-cont">
                    <h5>{{"Instagram Feed" | translate}}</h5>
                    <div class="insta-posts">
                        <!-- <span><img src="assets/image/dummy-insta.png" alt=""></span>
                        <span><img src="assets/image/dummy-insta.png" alt=""></span>
                        <span><img src="assets/image/dummy-insta.png" alt=""></span>
                        <span><img src="assets/image/dummy-insta.png" alt=""></span> -->

<!-- <div class="elfsight-app-812e4452-17c6-4c3d-9824-79e29b7d1f33" data-elfsight-app-lazy></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="copyrights-footer">
    <p>{{"Copyright © 2023 .All rights reserved by" | translate}} <a href="#">{{companyName | translate}}</a>.</p>
</div>
